import { useSyncExternalStore } from "react";

export type TabVisibility = "visible" | "hidden";

const listeners = new Set<() => void>();
let current: TabVisibility =
  typeof document !== "undefined" && document.visibilityState === "hidden" ? "hidden" : "visible";
let attached = false;

function read(): TabVisibility {
  return current;
}

function notify() {
  for (const listener of listeners) listener();
}

function ensureAttached() {
  if (attached || typeof document === "undefined") return;
  attached = true;
  document.addEventListener("visibilitychange", () => {
    const next: TabVisibility = document.visibilityState === "hidden" ? "hidden" : "visible";
    if (next !== current) {
      current = next;
      notify();
    }
  });
}

function subscribe(listener: () => void) {
  ensureAttached();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useTabVisibility(): TabVisibility {
  return useSyncExternalStore(subscribe, read, read);
}
